module.exports = __webpack_public_path__ + "img/btn-play.9b2b889a.png";